import styled from 'styled-components'

import { ButtonStyleProps, buttonStyles } from './button.styles'

export const ButtonStyled = styled('button').withConfig({
  shouldForwardProp: (prop) => !['buttonTheme', 'minWidth', 'textWrap', 'buttonHeight'].includes(prop)
})<ButtonStyleProps>`
  ${buttonStyles}
`
